<template>
  <!--:TODO: Force min date -->
  <weekly-execution
    is-extranet
    report-mode
    :min-date="MIN_DATE"
    :highways="highways"
    :default-from-date="FROM_DATE"
    :fetch-source="{
      fetchReal,
      fetchExpected,
    }"
    :gantt-props="{
      sinistersURL: 'siniestros/carreteros/cliente',
    }"
  >
    <span slot="empty-content-action">
      <!--Nothing to do buddy-->
    </span>
  </weekly-execution>
</template>

<script>

import WeeklyExecution from '@/pages/WorkPlan/WeeklyExecution/Index'
import extranetService from '@/services/customersExtranet/'
import catalogService from '@/services/catalog/'
import moment from "moment";

// Sinisters are valid (clientwise) from this point on
const MIN_DATE = moment("2021-10-01")
const DAYS_AGO_15 = 
  moment()
      .subtract(15, "days")

const FROM_DATE = (DAYS_AGO_15.isBefore(MIN_DATE) ? MIN_DATE : DAYS_AGO_15)
  .format("YYYY-MM-DD")

export default {

  components: {
    WeeklyExecution
  },

  data() {
    const { fetchReal, fetchExpected } = extranetService
    return {
      fetchReal, fetchExpected,
      highways: [],
      MIN_DATE: MIN_DATE.toDate().toISOString(),
      FROM_DATE
    }
  },

  methods: {
    fetchHighways() {
      return catalogService.fetch('highway/extranet')
        .then(highways => this.highways = highways)
    }
  },

  mounted() {
    this.fetchHighways()
  }

}
</script>




// WEBPACK FOOTER //
// src/pages/CustomersExtranet/ExecutionReport.vue